module.exports = __webpack_public_path__ + "static/media/canciones.81a61c85.PNG";